import PartnerGlobalPicker from '@snowit/components/Pickers/PartnerGlobalPicker';
import QuickJump from '@snowit/components/QuickJump';
import useBreakpoints from '@snowit/hooks/useBreakpoints';
import useAuth from '@snowit/system/useAuth';

import TenantGlobalPicker from '../Pickers/TenantGlobalPicker';
import QuickJumpSwitch from '../QuickJump/QuickJumpSwitch';
import Menu from './Menu';

import cx from 'classnames';
import s from './Sidebar.module.scss';

type SidebarProps = {
  className?: string;
  shrunk?: boolean;
  sidebarOnClick?: () => void;
  // onClick: () => void;
};

const Sidebar = (props: SidebarProps) => {
  const { className, shrunk, sidebarOnClick } = props;
  const { minWidth } = useBreakpoints();
  const { authType } = useAuth();

  const renderQuickJump = () => {
    if (authType !== 'ADMIN') return null;
    return (
      <div className={s.wrapQuickJump}>
        <QuickJump />
      </div>
    );
  };

  const renderSwitch = () => {
    if (authType !== 'ADMIN') return null;
    return (
      <div className={s.wrapQuickJump}>
        <QuickJumpSwitch />
      </div>
    );
  };

  const renderPickers = () => {
    if (minWidth.md) return null;
    return (
      <div className={s.wrapPicker}>
        <TenantGlobalPicker />
        <PartnerGlobalPicker small />
      </div>
    );
  };

  return (
    <div className={cx(s.sidebar, className, { [s.shrunk]: shrunk })}>
      {renderQuickJump()}
      {renderPickers()}

      <Menu className={s.menu} shrunk={shrunk} sidebarOnClick={sidebarOnClick} />
      {renderSwitch()}
      <div className={s.poweredBy}>
        <span>{'powered by Snowit'}</span>
        <span>{`version: ${process.env.SNOWIT_VERSION_HASHED}`}</span>
        <span>{`date: ${process.env.SNOWIT_DEPLOY_DATE}`}</span>
      </div>
    </div>
  );
};

export default Sidebar;
